













































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
const Root = namespace("root");

@Component({})
export default class channelEditMultiLanguage extends Vue {
  @Prop({ default: () => [] }) languageList;
  @Prop({ default: () => {} }) editData;
  @Prop({ default: "requireOption" }) rule;
  @Prop({ default: "text" }) inputType;
  dialogVisible: boolean = false;

  ruleForm: any = {
    mutiLang: ""
  };
  get rules() {
    return {
      requireOption: [
        {
          required: true,
          message: this.$t("Product.require"),
          trigger: "blur"
        }
      ]
    };
  }

  @Watch("dialogVisible")
  watchDialogVisible(val) {
    let $form: any = this.$refs.form;
    if (val) {
      let $form: any = this.$refs.form;
      $form && $form.clearValidate();
      this.ruleForm = {
        mutiLang: {
          ...this.editData
        }
      };
    } else {
      $form && $form.resetFields();
    }
  }
  handleSubmit() {
    const $form: any = this.$refs["form"];
    $form.validate(valid => {
      if (valid) {
        this.handleConfirm();
      }
    });
  }
  handleConfirm() {
    console.log(this.ruleForm.mutiLang, 9976);

    this.$emit("save", this.ruleForm.mutiLang);
    this.dialogVisible = false;
  }
}
